import React from 'react';
import createSVG from './createSVG';

const LogoutIcon = ({style}) => (
  <path style={style} d="M13.1106 24.596c6.302 0 11.4105-5.14 11.4105-11.482 0-1.879-.4485-3.6523-1.2437-5.2178-1.8885-3.7176-5.7322-6.263-10.1667-6.263C6.8086 1.6333 1.7 6.7737 1.7 13.114c0 6.342 5.1086 11.482 11.4106 11.482zM13.1106 13.1143V.9" stroke="#7D7D7D" strokeWidth="1.71" fill="none" fillRule="evenodd"/>
);

export default createSVG(LogoutIcon);
